import { __awaiter } from '../../_virtual/_tslib.js';
import { useQueryClient, useMutation } from 'react-query';
import { toast } from '../../components/toast/toast.js';
import '../../constants/authorizedUsers.js';
import '../../constants/bidStatus.js';
import '../../constants/bulkLoadCardStatus.js';
import '../../constants/misc.js';
import '../../constants/event-names.js';
import '../../constants/eventsMapObj.js';
import '../../constants/Faq.js';
import '../../constants/languages.js';
import '../../constants/loadStatus.js';
import '../../constants/lorryStatus.js';
import '../../constants/lorryTypes.js';
import '../../constants/mostSearchedLinks.js';
import '../../constants/Pages.js';
import 'react';
import '../../constants/serviceTypeId.js';
import '../../constants/StateList.js';
import '../../constants/bidUpdateType.js';
import '../../constants/userAction.js';
import '../../constants/api.js';
import '../../constants/link.js';
import '../../constants/market.js';
import '../../constants/payment.js';
import '../../constants/admin/screenId.js';
import API from '../const.js';
import 'bowser';
import '../auth.service.js';
import { getAuthIdParam } from '../../methods/getAuthIdParam.js';
import 'react-cookie';
import '../../methods/formatDate.js';
import '../../methods/getTransporterFigure.js';
import '../../methods/getDownloadsFigure.js';
import 'lodash.isequal';
import '../../methods/getPageLoadSourceUTMParam.js';
import 'crypto-js';
import { getAuthHeader } from '../utils/getAuthHeader.js';
import { QueryNames } from './queryNames.js';

function useSubmitLoadBid() {
    const queryClient = useQueryClient();
    // Removed data and error props to remove warning, can be addded when need
    const { isLoading, isError, isSuccess, mutateAsync } = useMutation(({ formData, loadId, companyId }) => fetch(API.SUBMIT_LOAD_BID + getAuthIdParam(), {
        method: "POST",
        headers: Object.assign({}, getAuthHeader()),
        body: JSON.stringify({
            amount: formData === null || formData === void 0 ? void 0 : formData.amount,
            type: (formData === null || formData === void 0 ? void 0 : formData.isFixedPrice) ? 0 : 1,
            is_negotiable: formData === null || formData === void 0 ? void 0 : formData.isNegotiable,
            is_vehicle_available: true,
            bidder_comment: formData === null || formData === void 0 ? void 0 : formData.remarks,
            load_id: loadId,
            bidder_id: Number(companyId),
            quantity: parseFloat(String(formData === null || formData === void 0 ? void 0 : formData.lorryCapacity)),
            lorry_id: formData === null || formData === void 0 ? void 0 : formData.lorryId
        })
    }), {
        onSuccess: (res) => {
            if (res.status === 401) {
                queryClient.invalidateQueries(QueryNames.validateToken);
            }
            if (res.status === 200) {
                queryClient.invalidateQueries([QueryNames.bidHistory, "load"]);
                queryClient.invalidateQueries([QueryNames.loadSearch]);
            }
        }
    });
    return { isLoading, isError, isSuccess, mutateAsync };
}
function useSubmitLorryBid() {
    const queryClient = useQueryClient();
    // Removed data and error props to remove warning, can be addded when need
    const { isLoading, isError, isSuccess, mutateAsync } = useMutation(({ formData, lorryId, companyId }) => fetch(API.SUBMIT_LORRY_BID + getAuthIdParam(), {
        method: "POST",
        headers: Object.assign({}, getAuthHeader()),
        body: JSON.stringify({
            amount: parseFloat(String(formData === null || formData === void 0 ? void 0 : formData.amount)),
            type: (formData === null || formData === void 0 ? void 0 : formData.isFixedPrice) ? 0 : 1,
            is_negotiable: formData === null || formData === void 0 ? void 0 : formData.isNegotiable,
            load_id: formData === null || formData === void 0 ? void 0 : formData.loadId,
            lorry_id: lorryId,
            quantity: parseFloat(String(formData === null || formData === void 0 ? void 0 : formData.qty)),
            bidder_comment: (formData === null || formData === void 0 ? void 0 : formData.remarks) || "",
            bidder_id: Number(companyId)
        })
    }), {
        onSuccess: (res) => {
            if (res.status === 401) {
                queryClient.invalidateQueries(QueryNames.validateToken);
            }
            if (res.status === 200) {
                queryClient.invalidateQueries("my-load-bids");
                queryClient.invalidateQueries("getLiveLorries");
                queryClient.invalidateQueries([QueryNames.bidHistory, "lorry"]);
                queryClient.invalidateQueries([QueryNames.lorrySearch]);
            }
        }
    });
    return { isLoading, isError, isSuccess, mutateAsync };
}
function handleSubmitBidResponse(mutateFn, submitBidParams) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const bidRes = yield mutateFn(submitBidParams);
            if (bidRes.status === 200) {
                return { success: true };
                //sucess toast
            }
            if (!bidRes.ok) {
                const msg = (yield bidRes.json()).message;
                const error = { message: msg };
                throw error;
            }
        }
        catch (e) {
            toast.error(e.message || "An error occured, please try again");
            return { success: false };
        }
        return { success: false };
    });
}
function handleSubmitLoadBidResponse(mutateFn, submitBidParams) {
    return __awaiter(this, void 0, void 0, function* () {
        return handleSubmitBidResponse(mutateFn, submitBidParams);
    });
}
function handleSubmitLorryBidResponse(mutateFn, submitBidParams) {
    return __awaiter(this, void 0, void 0, function* () {
        return handleSubmitBidResponse(mutateFn, submitBidParams);
    });
}

export { handleSubmitLoadBidResponse, handleSubmitLorryBidResponse, useSubmitLoadBid, useSubmitLorryBid };
//# sourceMappingURL=useBidService.js.map
